<!-- 商户-订单管理 -->
<template>
  <div class="user_service-page" v-cloak>
    <van-nav-bar :border="false" left-arrow fixed title="商户-订单管理" class="user_work_order_nav_bar" @click-left="onClickLeft" :z-index="20" :style="'background: #2998FF; color:#FFFFFF;'"></van-nav-bar>
 <!-- 列表 -->
    <van-sticky :offset-top="46" :z-index="11">
      <div class="header-tips">
        <p>累计消费(元)</p>
        <p class="pice">{{orderTotal}}</p>
      </div>
    </van-sticky>
    <!-- 列表 -->
    <div class="list">
      <van-list v-model="loading" :finished="finished" finished-text="没有更多了" @load="getList">
        <div class="item" v-for="(item, index) in list" :key="index">

          <!-- 内容 -->
          <div class="center-block"> 
            <p class="tips"><span>用户名称:{{item.userName}}</span>
              <span v-if="item.status == 0" class="yy">{{item.status_name}}</span>
              <span v-if="item.status == 1" class="wy">{{item.status_name}}</span>
            </p>
            <p class="phone">{{item.phoneNo}}</p>
            <p class="name">设备名称:{{item.machine_names}}</p>
            <p class="text">站点:{{item.station_name}}</p>
            <span v-if="item.status == 0" class="js-btn" @click="jsOrder(item,index)">结算</span>
          </div>

        </div>
      </van-list>
    </div>

    <!-- <div class="list" v-else>
       <van-divider>没有更多了~</van-divider>
     </div> -->

    <van-empty class="custom-image" v-if="list.length < 1" />
  </div>
</template>

<script type="text/babel">
export default {
  name: "m-order-list",
  components: {},
  props: {},
  data() {
    return {
      orderTotal: 0, //订单统计

      list: [
        // {
        //   id: "订单编号",
        //   userName: "用户昵称",
        //   phoneNo: "用户手机号码",
        //   machineId: "设备iid",
        //   stationId: "站点id",
        //   status: "状态id：0=进行中 1=已完成",
        //   station_name: "站点名称",
        //   machine_names: "设备名称",
        //   status_name: "状态名称：进行中，已完成",
        // },
      ],
      pageNum: 1,
      pageSize: 10,
      loading: false,
      finished: false,
    };
  },
  watch: {},
  created() {},
  mounted() {
    this.m_order_total(); //充值合计

  },
  methods: {
    getList() {
      this.$toast.loading();
      let _this = this;
      let data = {
        page: _this.pageNum,
        limit: _this.pageSize,
      };
      _this.$post("/api/m_order_list", data, data).then((res) => {
        // console.log(res.data);
        this.$toast.clear();
        _this.loading = false; // 加载状态结束

        if (res.data.code == 0) {
          // console.log(res.data.data);
          let lists = res.data.data;

          if (lists && lists.length > 0) {
            if (_this.pageNum == 1) {
              _this.list = [];
              _this.list = lists;
            } else {
              _this.list = _this.list.concat(lists);
            }
            _this.pageNum++;
            if (lists.length < _this.pageSize) {
              _this.finished = true; // 数据全部加载完成
            }
          } else {
            console.log("444");
            _this.finished = true; // 数据全部加载完成
          }
        } else {
          console.log("555");
          _this.$toast.fail(res.data.message);
          _this.finished = true;
        }
      });
    },
      m_order_total() {
      let _this = this; 
      _this.$post("/api/m_order_total",).then((res) => {
        // console.log(res.data);
        this.$toast.clear(); 

        if (res.data.code == 0) {
          console.log(res.data.data, "充值合计");
          _this.orderTotal = res.data.data.total;
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    jsOrder(even, int) {
      console.log(even);
      let _this = this;
      let item = JSON.parse(JSON.stringify(even));
      let data = {
        order_id: item.id,
      };
      _this.$post("/api/wash_settle", data, data).then((res) => {
        // console.log(res.data);
        this.$toast.clear();
        if (res.data.code == 0) {
          _this.$toast.success(res.data.message);
          setTimeout(function () {
            _this.list = [];
            _this.pageNum = 1;
            _this.loading = true;
            _this.finished = false;
            _this.getList();
          }, 1000);
        } else {
          _this.$toast.fail(res.data.message);
        }
      });
    },
    // 返回上一页
    onClickLeft() {
      this.$router.go(-1);
    },
  },
};
</script>

<style lang="scss">
.user_service-page {
  // 空状态
  .custom-image .van-empty__image {
    width: 260px;
    height: 300px;
  }
}
.user_work_order_nav_bar {
  .van-nav-bar__content {
    .van-icon,
    .van-nav-bar__title {
      color: #fff;
    }
  }
}
</style>


<style lang="scss" scoped>
.user_service-page {
  height: 100%;
  width: 100%;
  padding: 50px 0;
  background-color: #f7f7f7;
  overflow-x: scroll;
  -webkit-overflow-scrolling: touch;
  .list {
    padding: 0 10px;
  }
  .yy {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #2cc05d;
  }
  .wy {
    font-size: 12px;
    font-family: Source Han Sans CN;
    font-weight: 400;
    color: #3573f8;
  }
  .item {
    margin: 15px 0;
    background-color: #fff;
    box-shadow: 0px 2px 5px rgba(69, 79, 99, 0.06);
    // overflow: hidden;
    border-radius: 5px;
    // 内容模块
    .center-block {
      width: 100%;
      height: 100%;
      position: relative;

      // background-color: #eee;
      display: flex;
      flex-direction: column;
      justify-content: center;

      padding: 15px;

      .tips {
        font-size: 15px;

        display: flex;
        justify-content: space-between;
        align-items: center;
        font-family: Source Han Sans CN;
        color: #333333;
        font-weight: bold;
        margin-bottom: 10px;
      }
      .phone {
        font-size: 13px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        color: #333333;
        margin-bottom: 10px;
        font-weight: 500;
        text-align: left;
      }
      .name {
        font-size: 12px;

        font-family: Source Han Sans CN;
        margin-bottom: 10px;
        font-weight: 500;
        // line-height: 26px;
        color: #cccccc;
        text-align: left;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 1; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }
      .text {
        text-align: left;
        font-size: 12px;
        font-family: Source Han Sans CN;
        font-weight: 400;
        line-height: 17px;
        color: #cccccc;
        // display: -webkit-box; /*作为弹性伸缩盒子模型显示*/
        // -webkit-line-clamp: 3; /*显示的行数；如果要设置2行加...则设置为2*/
        // overflow: hidden; /*超出的文本隐藏*/
        // text-overflow: ellipsis; /* 溢出用省略号*/
        // -webkit-box-orient: vertical; /*伸缩盒子的子元素排列：从上到下*/
      }

      .js-btn {
        position: absolute;
        right: 10px;
        bottom: 20px;
        background-color: #3f7cff;
        color: #fff;
        font-size: 12px;
        padding: 5px 10px;
        z-index: 3;
        border-radius: 5px;
      }
    }
  }
}
.click:active {
  transform: scale(0.95);
  -webkit-transform: scale(0.95);
  -moz-transform: scale(0.95);
}

.header-tips {
  background-color: #fff;
  font-size: 13px;
  font-family: Source Han Sans CN;
  font-weight: 400;
  color: #333333;
  padding: 10px 0;
  .pice {
    font-size: 25px;
    font-family: Source Han Sans CN;
    font-weight: 500;
    color: #333333;
    margin-top: 5px;
  }
}
</style>
